import { css } from "../../css/util.compose-css";

export const address = css`
  font-style: inherit;
`;
